import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AddCaretakerBox } from './AddCaretakerBox';
import { EditCaretakersBox } from './EditCaretakersBox';
import { RaiseBox } from './RaiseBox';
import DeleteCaretakerDialog from './DeleteCaretakerDialog';
import './caretakersPage.css';

export default function CaretakersPage({
  isAdmin,
  addCaretaker,
  addUser,
  caretakerList,
  loadCaretakers,
  InitialLoadShifts,
  setCaretakerToDeleteID,
  setCaretakerToDeleteName,
  displayDeleteCaretakerDialog,
  setDisplayDeleteCaretakerDialog,
  caretakerToDeleteName,
  caretakerToDeleteID,
  setUserToDeleteID,
  userToDeleteID,
  userList,
  caretakerMasterList,
  deactivatedCaretakersList,
  restoreCaretaker,
  masterEventList,
}) {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAdmin === false) navigate('/');
  }, [isAdmin, navigate]);

  return (
    <div className="caretakersPageDiv">
      <div className="caretakersPageHeader">
        <Link to="/" className="backToHomeLink">← Back to Home</Link>
        <h2 className="caretakersPageTitle">Caretakers</h2>
      </div>

      <div className="formSep"></div>
      <AddCaretakerBox
        addCaretaker={addCaretaker}
        addUser={addUser}
      />

      <div className="formSep"></div>
      <EditCaretakersBox
        caretakerList={caretakerList}
        InitialLoadCaretakers={loadCaretakers}
        InitialLoadShifts={InitialLoadShifts}
        setCaretakerToDeleteID={setCaretakerToDeleteID}
        setCaretakerToDeleteName={setCaretakerToDeleteName}
        setDisplayDeleteCaretakerDialog={setDisplayDeleteCaretakerDialog}
        setUserToDeleteID={setUserToDeleteID}
        userList={userList}
        caretakerMasterList={caretakerMasterList}
        deactivatedCaretakersList={deactivatedCaretakersList}
        restoreCaretaker={restoreCaretaker}
      />

      <div className="formSep"></div>
      <RaiseBox
        caretakerList={caretakerList}
      />

      <DeleteCaretakerDialog
        displayDeleteCaretakerDialog={displayDeleteCaretakerDialog}
        setDisplayDeleteCaretakerDialog={setDisplayDeleteCaretakerDialog}
        InitialLoadCaretakers={loadCaretakers}
        InitialLoadShifts={InitialLoadShifts}
        setCaretakerToDeleteName={setCaretakerToDeleteName}
        caretakerToDeleteName={caretakerToDeleteName}
        setCaretakerToDeleteID={setCaretakerToDeleteID}
        caretakerToDeleteID={caretakerToDeleteID}
        userToDeleteID={userToDeleteID}
        masterEventList={masterEventList}
      />
    </div>
  );
}
